<script>
    import { Router, Route, link } from 'svelte-routing';

    import Header from '../components/Header.svelte';
    import Footer from '../components/Footer.svelte';

    import PurchaseReceiver from '../receivers/PurchaseReceiver.svelte';
    import PurchaseReceiverSky from '../receivers/PurchaseReceiverSky.svelte';
    import PaypalSuccessPurchaseReceiver from '../receivers/PaypalSuccessPurchaseReceiver.svelte';
    import PaypalCancelPurchaseReceiver from '../receivers/PaypalCancelPurchaseReceiver.svelte';

    // Store
    import { store } from '../Store.svelte';
</script>

<div>
    <Header />
    <main
        class:secondary-font={$store.requestedServices.isSky}
        class:secondary-body-bg={$store.requestedServices.isSky}
        class:isSky={$store.requestedServices.isSky}
    >
        <Router url="receiver">
            <Route path="purchase/*" component={PurchaseReceiver} />
            <Route path="purchase-sky/*" component={PurchaseReceiverSky} />
            <Route
                path="billing-agreement/success"
                component={PaypalSuccessPurchaseReceiver}
            />
            <Route
                path="billing-agreement/cancel"
                component={PaypalCancelPurchaseReceiver}
            />
        </Router>
    </main>
    <Footer />
</div>
